import { useRequiredPrepMillisecond } from "@/components/features/items/edit/_shared/ui/components/main/questions/required-prep-milli";

import { useAccommodationHotelPolicyFormModelContext } from "../../../../../../context";

export const useReservationRequiredPrepMillisecond = () => {
	const { viewModel, onSetViewModel } = useAccommodationHotelPolicyFormModelContext();
	const { requiredPrepMillisecond, requiredPrepMillisecondBeforeDate, requiredPrepMillisecondBeforeHour } = viewModel;

	return useRequiredPrepMillisecond({
		requiredPrepMillisecond,
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
		onSet: onSetViewModel,
	});
};
